function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null || a[orderBy] === undefined) {
    return 1;
  }
  if (b[orderBy] === null || b[orderBy] === undefined) {
    return -1;
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  if (order !== "asc" && order !== "desc") {
    throw new Error("Invalid order parameter: must be 'asc' or 'desc'");
  }

  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export { descendingComparator, getComparator };
